export const PROVIDER_GROUP = "Proveedores";
export const PROVIDER = "Proveedor";
